/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Auth from "../../shared/Auth";
import Globals from "../../shared/Globals";
import { qreq } from "../../shared/qrequest";
import AppActions from "../AppActions";
import BaseCom from "../BaseCom";
import Card from "../Card";
import FormInput from "../FormInput";
import Icon from "../Icon";
import { Pop } from "../PopModal";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import L from "../Lang";
import { SidebarGlobal } from "../_SidebarGlobal";

class PackageSlip extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            item: {},
            errors: [],
            products: [],
            validated: false
        };
    }

    async componentDidMount() {
        await this.load();
        await this.loadPO();
        await this.loadProducts();
        SidebarGlobal.setSubNav(<>
            <button type="submit" className="btn btn-success">
                <Icon icon="faBox" /> <L>Package</L>
            </button>
        </>);
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load = async () => {
        try {
            let j = await qreq.getAsync('/api/package-slip/po/' + this.props.params.poID);
            if (j.item) {
                this.setState({ item: j.item });
                this.validate(j.item);
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    loadPO = async () => {
        try {
            await this.fillItemAsync('/api/purchase-order/get/' + this.props.params.poID, 'purchaseOrder');
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    loadProducts = async () => {
        try {
            let j = await qreq.postAsync('/api/product/list', {});
            if (j.list) {
                this.setState({ products: j.list });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    submit = (e) => {
        e?.preventDefault();
        Pop.showConfirm(<div><L>Are you sure you want to package this packing slip?</L></div>, 'Send Packing Slip', async () => {
            this.setState({ submitting: true });
            try {
                let j = await qreq.postAsync('/api/package-slip/send', this.state.item);
                if (j.errorCode === 0) {
                    this.success('Packing slip sent.');
                    this.goBack();
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
            this.setState({ submitting: false });
        });
    }

    validate = (item) => {
        let errors = [];
        item?.items?.forEach((item, idx) => {
            if (!item.lotNumber)
                errors.push(`Lot Number is required for item ${idx + 1}.`);
            if (!item.expirationDate)
                errors.push(`Expiration Date is required for item ${idx + 1}.`);
        });
        this.setState({ errors, validated: errors.length === 0 });
        return errors.length === 0;
    }

    downloadPDF = () => {
        window.open(Globals.serverUrl + '/api/package-slip/pdf/' + this.state.item.id + '/packing-slip-' + this.state.purchaseOrder.iid + '.pdf', '_blank');
    }

    downloadCSV = () => {
        window.open(Globals.serverUrl + '/api/package-slip/csv/' + this.state.item.id + '/packing-slip-' + this.state.purchaseOrder.iid + '.csv', '_blank');
    }

    getSize = (item) => {
        const prod = this.state.products.find(x => x.id === item.productID);
        if (prod?.isPricePerUnit) return item.productSize;
        else return 'Standard';
    }

    render() {
        return (
            <div className="container-fluid">
                <h1><L>Packing Slip</L></h1>
                <form onSubmit={this.submit}>
                    <AppActions>
                        {this.state.validated && !this.state.item?.isSent && <button type="submit" className="btn btn-success btn-lg" disabled={this.state.submitting}>
                            <Icon icon="faBox" /> <L>Package</L></button>}

                        {this.state.item?.isSent && <>
                            <button type="button" className="btn btn-primary btn-lg" onClick={this.downloadPDF}>
                                <Icon icon="faFilePdf" /> <L>PDF</L></button>
                            <button type="button" className="btn btn-secondary btn-lg" onClick={this.downloadCSV}>
                                <Icon icon="faFileCsv" /> <L>CSV</L></button>
                        </>}
                    </AppActions>

                    <Card title="Packing Slip">
                        <FormInput model={this.state.item}
                            name="shippingCarrierID"
                            label="Shipping Carrier"
                            type="select"
                            selectDefault="FedEx"
                            disabled={true}
                            options={[{ id: 0, name: 'FedEx' }]} />
                        <FormInput model={this.state.item}
                            name="trackingNumber"
                            label="Tracking Number"
                            disabled={!Auth.hasRole('manager') || this.state.item?.isSent} />
                        <p className="text-muted"><L>You can submit the packing slip without a tracking number, then add the tracking number once shipped.</L></p>
                    </Card>

                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th><L>#</L></th>
                                <th><L>Code</L></th>
                                <th><L>Item</L></th>
                                <th><L>Size</L></th>
                                <th><L>Lot Number</L></th>
                                <th><L>Expiration Date</L></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.item?.items?.map((item, idx) => (
                                <tr key={idx}>
                                    <td>{idx + 1}</td>
                                    <td>{item.catalogCode}</td>
                                    <td>{item.productName}</td>
                                    <td>{this.getSize(item)}</td>
                                    <td>{item.lotNumber}</td>
                                    <td>{Globals.toMDYDateString(item.expirationDate)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </form>
            </div>
        );
    }
}

export default withParamsAndNavigate(PackageSlip);